























































































import {Component, Vue, Watch} from 'vue-property-decorator'
import {MetaInfo} from 'vue-meta'
import Navbar from '@/components/navbar/Navbar.vue'
import AppFooter from '@/components/footer/AppFooter.vue'
import {GithubOrganizationCollection} from '@/model/collection/GithubOrganizationCollection'
import CDOrganizationsSection from '@/components/communityDevelopment/CDOrganizationsSection.vue'
import CDLastCommitsSection from '@/components/communityDevelopment/CDLastCommitsSection.vue'
import CDActivityVolumeSection from '@/components/communityDevelopment/CDActivityVolumeSection.vue'
import CDLastActiveProjectsSection from '@/components/communityDevelopment/CDLastActiveProjectsSection.vue'
import {GithubRepositoryCollection} from '@/model/collection/GithubRepositoryCollection'
import {GithubRepositoryCommitCollection} from '@/model/collection/GithubRepositoryCommitCollection'
import {$} from '@/facade'
import CDTopLanguages, {
  CDLanguageRatioItem,
} from '@/components/communityDevelopment/CDTopLanguages.vue'
import CDOrganizationMobileInfoCard from '@/components/communityDevelopment/CDOrganizationMobileInfoCard.vue'
import {GithubRepositoryLanguageCollection} from '@/model/collection/GithubRepositoryLanguageCollection'
import {GithubOrganizationSocialTypeCollection} from '@/model/collection/GithubOrganizationSocialTypeCollection'
import {GithubOrganization} from '@/model/resource/GithubOrganization'
import {GithubRepository} from '@/model/resource/GithubRepository'
import {GithubOrganizationSocialType} from '@/model/resource/GithubOrganizationSocialType'

@Component({
  components: {
    Navbar,
    CDOrganizationsSection,
    CDLastCommitsSection,
    CDActivityVolumeSection,
    CDLastActiveProjectsSection,
    AppFooter,
    CDTopLanguages,
    CDOrganizationMobileInfoCard,
  },
})
export default class CommunityDevelopmentView extends Vue {
  organizationCollection = new GithubOrganizationCollection()
  repositoryCollection = new GithubRepositoryCollection()
  repositoryCommitCollection = new GithubRepositoryCommitCollection()
  lastActiveRepositoryCollection = new GithubRepositoryCollection()
  activityRepositoryCollection = new GithubRepositoryCollection()
  activityRepositoryCommitCollection = new GithubRepositoryCommitCollection()

  selectedOrganizationId: number | null = null
  selectedRepositoryId: number | null = null
  /** After org wheel jump, select first or last repo in loaded project list. */
  pendingWheelRepoEdge: 'first' | 'last' | null = null
  private orgChangeResolve: (() => void) | null = null
  commitsByOrganization: Record<number, number> = {}
  isSelectionLoading = false
  topLanguages: CDLanguageRatioItem[] = []
  allSocialTypes: GithubOrganizationSocialType[] = []

  get selectedOrganization(): GithubOrganization | null {
    if (this.selectedOrganizationId === null) return null
    return (
      this.organizationCollection.items.find(
        it => it.$id === this.selectedOrganizationId
      ) || null
    )
  }

  get selectedRepository(): GithubRepository | null {
    if (this.selectedRepositoryId === null) return null
    return (
      this.repositoryCollection.items.find(
        it => it.$id === this.selectedRepositoryId
      ) || null
    )
  }

  get filteredSocialTypes(): GithubOrganizationSocialType[] {
    if (this.selectedOrganizationId === null) return []
    return this.allSocialTypes.filter(
      s => s.githubOrganization?.$id === this.selectedOrganizationId
    )
  }

  get selectedOrganizationName(): string | null {
    if (this.selectedOrganizationId === null) return null
    const org =
      this.organizationCollection.items.find(
        it => it.$id === this.selectedOrganizationId
      ) || null
    return org?.name ?? org?.$tag ?? null
  }

  get selectedRepositoryName(): string | null {
    if (this.selectedRepositoryId === null) return null
    const repo =
      this.repositoryCollection.items.find(
        it => it.$id === this.selectedRepositoryId
      ) || null
    return repo?.name ?? null
  }

  metaInfo(): MetaInfo {
    const title = this.$translate(
      'metadata.title.communityDevelopment'
    ) as string
    const description = this.$translate(
      'view.communityDevelopment.metaDescription'
    ) as string

    return {
      title,
      meta: [
        {vmid: 'description', name: 'description', content: description},
        {vmid: 'og:title', property: 'og:title', content: title},
        {
          vmid: 'og:description',
          property: 'og:description',
          content: description,
        },
        {vmid: 'twitter:title', name: 'twitter:title', content: title},
        {
          vmid: 'twitter:description',
          name: 'twitter:description',
          content: description,
        },
      ],
    }
  }

  mounted() {
    this.applyCollection()
    this.populateResources()
  }

  applyCollection() {
    this.repositoryCollection.perPage = 10
    this.repositoryCollection.asc = false
    this.repositoryCollection.orderBy = 'committedAt'

    this.repositoryCommitCollection.perPage = 6
    this.repositoryCommitCollection.asc = false
    this.repositoryCommitCollection.orderBy = 'committedAt'

    this.lastActiveRepositoryCollection.perPage = 6
    this.lastActiveRepositoryCollection.asc = false
    this.lastActiveRepositoryCollection.orderBy = 'committedAt'

    this.activityRepositoryCollection.perPage = 6
    this.activityRepositoryCollection.asc = false
    this.activityRepositoryCollection.orderBy = 'committedAt'

    this.activityRepositoryCommitCollection.perPage = 999
    this.activityRepositoryCommitCollection.asc = false
    this.activityRepositoryCommitCollection.orderBy = 'committedAt'
  }

  async populateResources() {
    await this.organizationCollection.queryAsPage()

    this.repositoryCollection.idOrganizationFk = null
    this.repositoryCommitCollection.idOrganizationFk = null
    this.lastActiveRepositoryCollection.idOrganizationFk = null
    this.activityRepositoryCollection.idOrganizationFk = null
    this.activityRepositoryCommitCollection.idOrganizationFk = null

    await $.await.run('populateInitialData', () =>
      Promise.all([
        $.await.run('populateWheelContext', () =>
          Promise.all([
            this.repositoryCollection.queryAsPage(),
            $.await.run('populateLastCommits', () =>
              this.repositoryCommitCollection.queryAsPage()
            ),
          ])
        ),
        this.lastActiveRepositoryCollection.queryAsPage(),
        this.activityRepositoryCollection.queryAsPage(),
        this.activityRepositoryCommitCollection.queryAsPage(),
        this.populateCommitsByOrganization(),
        this.fetchAllSocialTypes(),
      ])
    )
    await $.await.run('populateTopLanguages', () => this.populateTopLanguages())
  }

  async fetchAllSocialTypes() {
    const collection = new GithubOrganizationSocialTypeCollection()
    collection.perPage = 200
    await collection.queryAsPage()
    this.allSocialTypes = collection.items
  }

  async populateTopLanguages() {
    const collection = new GithubRepositoryLanguageCollection()

    if (this.selectedRepositoryId !== null) {
      collection.idGithubRepositoryFk = this.selectedRepositoryId
      collection.idOrganizationFk = null
    } else {
      collection.idGithubRepositoryFk = null
      collection.idOrganizationFk = this.selectedOrganizationId
    }

    const response = await collection.sumByOrganization()

    type SumLanguage = {
      name?: string | null
      language?: string | null
      amountInBytes?: number | null
      ratio?: number | null
    }

    const languages: SumLanguage[] = Array.isArray((response as any)?.data)
      ? ((response as any).data as SumLanguage[])
      : ((response as any) as SumLanguage[])

    const totalBytes = languages.reduce(
      (acc: number, it: SumLanguage) => acc + (it.amountInBytes ?? 0),
      0
    )

    this.topLanguages = languages.map((it: SumLanguage) => {
      const amount = it.amountInBytes ?? 0
      const ratio =
        typeof it.ratio === 'number' && !Number.isNaN(it.ratio)
          ? it.ratio
          : totalBytes > 0
          ? amount / totalBytes
          : 0

      return {
        language: it.name ?? it.language ?? '',
        ratio,
      }
    })
  }

  @Watch('selectedOrganizationId')
  async onSelectedOrganizationIdWatch() {
    await this.onSelectedOrganizationIdChange()
  }

  async onSelectedOrganizationIdChange() {
    const orgId = this.selectedOrganizationId
    const orgSelected = orgId !== null

    this.isSelectionLoading = true
    this.selectedRepositoryId = null

    this.repositoryCollection.idOrganizationFk = orgId
    this.repositoryCollection.orderBy = orgSelected
      ? 'commitsCount'
      : 'committedAt'
    this.repositoryCommitCollection.idOrganizationFk = orgId
    this.repositoryCommitCollection.idGithubRepositoryFk = null

    this.activityRepositoryCollection.idOrganizationFk = orgId
    this.activityRepositoryCollection.orderBy = orgSelected
      ? 'commitsCount'
      : 'committedAt'
    this.activityRepositoryCollection.perPage = orgSelected ? 10 : 6
    this.activityRepositoryCommitCollection.idOrganizationFk = orgId

    this.lastActiveRepositoryCollection.idOrganizationFk = null

    const tasks: Array<Promise<unknown>> = [
      $.await.run('populateWheelContext', () =>
        Promise.all([
          $.await.run('populateProjects', () =>
            this.repositoryCollection.queryAsPage()
          ),
          $.await.run('populateLastCommits', () =>
            this.repositoryCommitCollection.queryAsPage()
          ),
        ])
      ),
      $.await.run('populateActivityVolume', () =>
        Promise.all([
          this.activityRepositoryCollection.queryAsPage(),
          this.activityRepositoryCommitCollection.queryAsPage(),
        ])
      ),
    ]

    if (!orgSelected) {
      tasks.push(
        $.await.run('populateLastActiveProjects', () =>
          this.lastActiveRepositoryCollection.queryAsPage()
        )
      )
    }

    try {
      await Promise.all(tasks)
      this.applyPendingWheelRepoPickAfterProjectsLoaded()
      await $.await.run('populateTopLanguages', () =>
        this.populateTopLanguages()
      )
    } finally {
      this.isSelectionLoading = false
      this.flushOrgChangeResolve()
    }
  }

  @Watch('selectedRepositoryId')
  async onSelectedRepositoryIdWatch() {
    this.isSelectionLoading = true
    this.repositoryCommitCollection.idGithubRepositoryFk = this.selectedRepositoryId
    try {
      await $.await.run('populateWheelContext', () =>
        $.await.run('populateLastCommits', () =>
          this.repositoryCommitCollection.queryAsPage()
        )
      )
      await $.await.run('populateTopLanguages', () =>
        this.populateTopLanguages()
      )
    } finally {
      this.isSelectionLoading = false
    }
  }

  async populateCommitsByOrganization() {
    const collection = new GithubRepositoryCommitCollection()
    const result = await collection.countByOrganization()
    this.commitsByOrganization = result as Record<number, number>
  }

  onSelectOrganization(id: number | null) {
    if (this.isSelectionLoading) return
    this.pendingWheelRepoEdge = null
    this.selectedOrganizationId = id
  }

  onSelectRepository(id: number | null) {
    if (this.isSelectionLoading) return
    this.pendingWheelRepoEdge = null
    this.selectedRepositoryId = id
  }

  private flushOrgChangeResolve() {
    if (this.orgChangeResolve) {
      const r = this.orgChangeResolve
      this.orgChangeResolve = null
      r()
    }
  }

  private applyPendingWheelRepoPickAfterProjectsLoaded() {
    const pick = this.pendingWheelRepoEdge
    if (pick === null || this.selectedOrganizationId === null) return
    const items = this.repositoryCollection.items
    if (!items.length) {
      this.pendingWheelRepoEdge = null
      return
    }
    this.pendingWheelRepoEdge = null
    this.selectedRepositoryId =
      pick === 'first' ? items[0].$id : items[items.length - 1].$id
  }

  private async awaitSelectionIdle(maxTicks = 30) {
    for (let i = 0; i < maxTicks; i++) {
      await this.$nextTick()
      if (!this.isSelectionLoading) {
        await this.$nextTick()
        if (!this.isSelectionLoading) return
      }
      await new Promise<void>(resolve => {
        const stop = this.$watch(
          () => this.isSelectionLoading,
          busy => {
            if (!busy) {
              stop()
              resolve()
            }
          }
        )
      })
    }
  }

  private async switchOrganizationForWheel(
    orgId: number,
    pick: 'first' | 'last' | null
  ): Promise<void> {
    const orgChanges = this.selectedOrganizationId !== orgId
    if (orgChanges) {
      await new Promise<void>(resolve => {
        this.orgChangeResolve = resolve
        this.pendingWheelRepoEdge = pick
        this.selectedOrganizationId = orgId
      })
    } else {
      this.pendingWheelRepoEdge = pick
      if (pick !== null) {
        this.applyPendingWheelRepoPickAfterProjectsLoaded()
      }
    }
    await this.awaitSelectionIdle()
  }

  private organizationsSortedByCommits(): GithubOrganization[] {
    return [...(this.organizationCollection.items || [])].sort((a, b) => {
      const ca = this.commitsByOrganization[a.$id] ?? 0
      const cb = this.commitsByOrganization[b.$id] ?? 0
      if (cb !== ca) return cb - ca
      return (a.name || a.$tag || '').localeCompare(b.name || b.$tag || '')
    })
  }

  async onWheelRepoNavigate(direction: 'prev' | 'next') {
    if (this.isSelectionLoading) return
    const orgs = this.organizationsSortedByCommits()
    if (!orgs.length) return

    if (this.selectedOrganizationId === null) {
      if (direction === 'next') {
        await this.switchOrganizationForWheel(orgs[0].$id, null)
      } else {
        await this.switchOrganizationForWheel(orgs[orgs.length - 1].$id, null)
      }
      return
    }

    const orgIdx = orgs.findIndex(o => o.$id === this.selectedOrganizationId)
    if (orgIdx < 0) return

    const repos = this.repositoryCollection.items

    if (this.selectedRepositoryId === null) {
      if (direction === 'next') {
        if (repos.length) this.onSelectRepository(repos[0].$id)
        else if (orgIdx < orgs.length - 1) {
          await this.switchOrganizationForWheel(orgs[orgIdx + 1].$id, null)
        }
      } else {
        const prevIdx = (orgIdx - 1 + orgs.length) % orgs.length
        await this.switchOrganizationForWheel(orgs[prevIdx].$id, null)
      }
      return
    }

    const repoIdx = repos.findIndex(r => r.$id === this.selectedRepositoryId)
    if (repoIdx < 0) return

    if (direction === 'next') {
      if (repoIdx < repos.length - 1) {
        this.onSelectRepository(repos[repoIdx + 1].$id)
        return
      }
      if (orgIdx >= orgs.length - 1) return
      await this.switchOrganizationForWheel(orgs[orgIdx + 1].$id, null)
      return
    }

    if (repoIdx > 0) {
      this.onSelectRepository(repos[repoIdx - 1].$id)
      return
    }
    const prevIdx = (orgIdx - 1 + orgs.length) % orgs.length
    await this.switchOrganizationForWheel(orgs[prevIdx].$id, null)
  }
}
